/* eslint-disable */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ActivationFoorchat from "../../components/services/Activation/Activationfoorchat";
import FoorchatSetting from "../../components/foorchat/foorchatSetting";
import FoorchatStats from "../../components/foorchat/foorchatStats";
import FoorchatChats from "../../components/foorchat/foorchatChats";

const FoorchatDashboard = ({ onDeactivate }) => {
  const [activeTab, setActiveTab] = useState("tab1");
  const { t } = useTranslation();

  return (
    <>
      <div className="m-3 mb-3 flex items-center justify-between">
        <div className="bg-white dark:!border-[#3c3a3d] dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden">
          <div className="flex">
            {/* Statistics tabs */}
            <button
              className={`flex items-center px-6 py-3 whitespace-nowrap transition-colors ${
                activeTab === "tab1"
                  ? "text-[#9e68ba] border-b-2 border-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#6e358c] dark:!text-gray-400 font-medium"
                  : "text-gray-600 hover:bg-[#6e358c] hover:bg-[#fcf6ff] dark:hover:bg-[#c06bed] dark:!text-gray-500"
              }`}
              onClick={() => setActiveTab("tab1")}
            >
              <span className="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9e68ba"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="7" height="7" x="3" y="3" rx="1" />
                  <rect width="7" height="7" x="14" y="3" rx="1" />
                  <rect width="7" height="7" x="14" y="14" rx="1" />
                  <rect width="7" height="7" x="3" y="14" rx="1" />
                </svg>
              </span>
              {t("foorchat.stats.title")}
            </button>

            {/* Settings tab */}
            <button
              className={`flex items-center px-6 py-3 whitespace-nowrap transition-colors ${
                activeTab === "tab2"
                  ? "text-[#9e68ba] border-b-2 border-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#6e358c] dark:!text-gray-400 font-medium"
                  : "text-gray-600 hover:bg-[#6e358c] hover:bg-[#fcf6ff] dark:hover:bg-[#c06bed] dark:!text-gray-500"
              }`}
              onClick={() => setActiveTab("tab2")}
            >
              <span className="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-settings text-[#9e68ba]"
                >
                  <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </span>
              {t("foorchat.settings.title")}
            </button>

            {/* Chats tab */}
            <button
              className={`flex items-center px-6 py-3 whitespace-nowrap transition-colors ${
                activeTab === "tab3"
                  ? "text-[#9e68ba] border-b-2 border-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#6e358c] dark:!text-gray-400 font-medium"
                  : "text-gray-600 hover:bg-[#6e358c] hover:bg-[#fcf6ff] dark:hover:bg-[#c06bed] dark:!text-gray-500"
              }`}
              onClick={() => setActiveTab("tab3")}
            >
              <span className="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9e68ba"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 6V2H8" />
                  <path d="M15 11v2" />
                  <path d="M2 12h2" />
                  <path d="M20 12h2" />
                  <path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" />
                  <path d="M9 11v2" />
                </svg>
              </span>
              {t("foorchat.chats.title")}
            </button>

            {/* Link Pages tab */}
            <button
              className={`flex items-center px-6 py-3 whitespace-nowrap transition-colors ${
                activeTab === "tab4"
                  ? "text-[#9e68ba] border-b-2 border-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#6e358c] dark:!text-gray-400 font-medium"
                  : "text-gray-600 hover:bg-[#6e358c] hover:bg-[#fcf6ff] dark:hover:bg-[#c06bed] dark:!text-gray-500"
              }`}
              onClick={() => setActiveTab("tab4")}
            >
              <span className="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9e68ba"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>
              </span>
              {t("foorchat.link_pages.title")}
            </button>
          </div>
        </div>
      </div>

      {activeTab === "tab1" && <FoorchatStats />}
      {activeTab === "tab2" && <FoorchatSetting onDeactivate={onDeactivate} />}
      {activeTab === "tab3" && <FoorchatChats />}
      {activeTab === "tab4" && <ActivationFoorchat />}
    </>
  );
};

export default FoorchatDashboard;
